import { render, staticRenderFns } from "./ScreeningEmrList.vue?vue&type=template&id=405cb198&scoped=true&"
import script from "./ScreeningEmrList.vue?vue&type=script&lang=js&"
export * from "./ScreeningEmrList.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningEmrList.vue?vue&type=style&index=0&id=405cb198&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405cb198",
  null
  
)

export default component.exports